import Text from 'components/Text/Text';
import React from 'react';
import { trueWordEnding } from 'utils/helpers';
import Pop from 'components/Popover/Pop';
import style from './AdditionalInfoList.module.scss';

interface IAdditionalInfoList {
	data: string[];
	singularTranslationKey: string;
	pluralTranslationKey: string;
}

const AdditionalInfoList: React.FC<IAdditionalInfoList> = ({ data, singularTranslationKey, pluralTranslationKey }) => {
	const translationString = trueWordEnding(data.length, singularTranslationKey, pluralTranslationKey);

	const Content = () => {
		return (
			<div className={style.content}>
				{data.map((el, i) => (
					<div className={style.item} key={el + String(i)}>
						<Text translationKey={el} size="xs" />
					</div>
				))}
			</div>
		);
	};

	return (
		<>
			{data.length > 1 ? (
				<>
					<Pop
						className={style.pop}
						withCloseIcon={false}
						placement="rightTop"
						content={<Content />}
						trigger="hover">
						<div className={style.showListBtn}>
							<Text
								className={style.bottomDotted}
								translationNameSpace="listing"
								translationKey={translationString}
								translationOptions={{
									count: data.length,
								}}
								theme="secondary"
								align="right"
								display="inline"
							/>
						</div>
					</Pop>
				</>
			) : (
				<Text translationKey={data.length ? data[0] : '-'} align="right" withTooltip={true} />
			)}
		</>
	);
};

export default React.memo(AdditionalInfoList);
